import { Wrap } from './styles';

/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional
 */
import { useEffect, useState } from 'react';

/**
 * Scale
 * 
 * @param {*} map
 * @param {boolean} updateWhenIdle Atualiza o estado qnd ocioso
 * @param {boolean} metric
 * @param {boolean} imperial
 * @param {*} props Resto
 * 
 * @returns 
 */
export const Scale = ({
  map,
  updateWhenIdle = false,
  metric = true,
  imperial = false,
  ...props
}) => {
  const maxWidth = 100;
  const [metricScaleWidth, setMetricScaleWidth] = useState(null);
  const [metricScaleValue, setMetricScaleValue] = useState(null);
  const [imperialScaleWidth, setIperialScaleWidth] = useState(null);
  const [imperialScaleValue, setImperialScaleValue] = useState(null);

  useEffect(() => {
    map.on(updateWhenIdle ? 'moveend' : 'move', update);
    map.whenReady(update);
  });

  const update = () => {
    let y = map.getSize().y / 2;

    let maxMeters = map.distance(
      map.containerPointToLatLng([0, y]),
      map.containerPointToLatLng([maxWidth, y])
    );

    updateScales(maxMeters);
  };

  const updateScales = (maxMeters) => {
    if (metric && maxMeters) {
      updateMetric(maxMeters);
    }
    if (imperial && maxMeters) {
      updateImperial(maxMeters);
    }
  };

  const updateMetric = (maxMeters) => {
    var meters = getRoundNum(maxMeters),
      label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';

    updateScale(label, meters / maxMeters);
  };

  const updateImperial = (maxMeters) => {
    var maxFeet = maxMeters * 3.2808399,
      maxMiles,
      miles,
      feet;

    if (maxFeet > 5280) {
      maxMiles = maxFeet / 5280;
      miles = getRoundNum(maxMiles);
      updateScale(miles + ' mi', miles / maxMiles, true);
    } else {
      feet = getRoundNum(maxFeet);
      updateScale(feet + ' ft', feet / maxFeet, true);
    }
  };

  /**
   * updateScale
   * 
   * @param {string} text 
   * @param {number} ratio 
   * @param {boolean} imperial 
   */
  const updateScale = (text, ratio, paramImperial = false) => {
    paramImperial
      ? setIperialScaleWidth(Math.round(maxWidth * ratio) + 'px')
      : setMetricScaleWidth(Math.round(maxWidth * ratio) + 'px');
    paramImperial ? setImperialScaleValue(text) : setMetricScaleValue(text);
  };

  const getRoundNum = (num) => {
    var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
      d = num / pow10;

    d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;

    return pow10 * d;
  };

  return (
    <Wrap metricWidth={metricScaleWidth} imperialWidth={imperialScaleWidth}>
      {metric && (
        <div className="scale">
          <div className="value">{metricScaleValue}</div>
          <div className="line"></div>
        </div>
      )}
      {imperial && (
        <div className="scale imperial">
          <div className="value imperial">{imperialScaleValue}</div>
          <div className="line imperial"></div>
        </div>
      )}
    </Wrap>
  );
};

Scale.properties = {
  id: 'CPN-MA-SCALE',
  alias: 'Escala',
  description: '...',
  ignore: true,
};

export default Scale;
